export const PageHeader = ({ eyebrow, title, description, actions }) => (
  <div className="rg-fade-in mb-8 flex flex-col gap-4 border-b border-[#1E2D4A] pb-6 md:flex-row md:items-end md:justify-between">
    <div>
      {eyebrow && <div className="rg-label mb-2 text-[#E5202E]/80">{eyebrow}</div>}
      <h1 data-testid="page-title" className="text-3xl font-bold uppercase tracking-wide text-slate-100 sm:text-4xl">
        {title}
      </h1>
      {description && <p className="mt-2 max-w-2xl text-sm text-slate-400">{description}</p>}
    </div>
    {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
  </div>
);

export const EmptyState = ({ icon: Icon, title, children, testId }) => (
  <div data-testid={testId} className="flex flex-col items-start gap-3 rounded-md border border-dashed border-[#1E2D4A] bg-[#050811]/60 p-8">
    {Icon && <Icon className="h-6 w-6 text-slate-500" aria-hidden />}
    <div className="font-display text-lg font-semibold uppercase tracking-wide text-slate-300">{title}</div>
    <div className="max-w-xl text-sm text-slate-500">{children}</div>
  </div>
);

export const Field = ({ label, children, hint }) => (
  <label className="block space-y-1.5">
    <span className="rg-label">{label}</span>
    {children}
    {hint && <span className="block text-xs text-slate-500">{hint}</span>}
  </label>
);

export const Card = ({ title, icon: Icon, right, children, className = "", testId }) => (
  <section data-testid={testId} className={`rg-card rg-corner rg-fade-in ${className}`}>
    {(title || right) && (
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
        <h2 className="flex items-center gap-2 text-lg font-semibold uppercase tracking-wider text-slate-200">
          {Icon && <Icon className="h-4 w-4 text-[#E5202E]" aria-hidden />}
          {title}
        </h2>
        {right}
      </div>
    )}
    {children}
  </section>
);
